import { defineMessages } from 'react-intl';

import { Switch } from 'atoms/inputs/Switch';
import { useCurrentUserContext } from 'contexts/currentUser';
import { LIFECYCLE, useLifecycle } from 'hooks/useLifecycle';

import { SettingsSection } from '../SettingsSection';

const messages = defineMessages({
  title: {
    id: 'Settings.commonPreferences.title',
    defaultMessage: 'Common Game',
  },
  description: {
    id: 'Settings.commonPreferences.description',
    defaultMessage: 'Hide Common Essence and Free Daily Pack',
  },
});

export const CommonPreferences = () => {
  const { currentUser } = useCurrentUserContext();
  const { update, lifecycle } = useLifecycle();
  const hideCommonFeatures = lifecycle?.hideCommonFeatures;

  if (!currentUser) return null;

  return (
    <SettingsSection
      title={messages.title}
      description={messages.description}
      toggleButton={
        <Switch
          checked={hideCommonFeatures}
          onChange={() => {
            update(LIFECYCLE.hideCommonFeatures, !hideCommonFeatures);
          }}
        />
      }
    />
  );
};
